var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-1/5 py-8 navbar",attrs:{"data-cy":"navbar"}},[_c('h3',{staticClass:"ml-32 text-2xl text-white navbar__brand",attrs:{"data-cy":"header-title"}},[_vm._v(" TO DO LIST APP ")])])
}]

export { render, staticRenderFns }